import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "donut-chart" }
const _hoisted_2 = {
  height: "34",
  width: "34",
  viewBox: "0 0 34 34"
}
const _hoisted_3 = ["stroke", "stroke-dashoffset", "transform"]

import { toRefs } from 'vue'

  interface Props {
    colors: Record<number, string>
    datasets: Record<number, Record<string, number>>
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    colors: null,
    datasets: null
  },
  setup(__props: any) {

const props = __props as {
    colors: Record<number, string>
    datasets: Record<number, Record<string, number>>
  }

  

  const { colors, datasets } = toRefs(props)
  let angleOffset = -90
  const cx = 16
  const cy = 16
  const radius = 14
  const circumference = 2 * Math.PI * radius

  function calculateStrokeDashOffset(
    percentage: number,
    circumference: number
  ): number {
    return circumference - percentage * circumference
  }
  function returnCircleTransformValue(
    index: number,
    percentage: number
  ): string {
    const rotation = `rotate(${angleOffset}, ${cx}, ${cy})`
    angleOffset = percentage * 360 + angleOffset
    return rotation
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_unref(datasets)), (data, index) => {
        return (_openBlock(), _createElementBlock("g", { key: index }, [
          _createElementVNode("circle", {
            cx: cx,
            cy: cy,
            r: radius,
            fill: "transparent",
            stroke: _unref(colors)[+data[0]],
            "stroke-dashoffset": 
            calculateStrokeDashOffset(data[1].percentage, circumference)
          ,
            "stroke-dasharray": circumference,
            "stroke-width": "3",
            "stroke-opacity": "0.8",
            transform: returnCircleTransformValue(index, data[1].percentage)
          }, null, 8, _hoisted_3)
        ]))
      }), 128))
    ]))
  ]))
}
}

})